import commonConstants from "$/data/common";
import { useRouteParams } from "$/util/router";
import { Close } from "@mui/icons-material";
import {
  Alert,
  Box,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link as LinkMui,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../util/auth";
import AuthForm from "./AuthForm";
import AuthSocial from "./AuthSocial";

function AuthModal(props: { open?: boolean; onClose: () => void }) {
  const auth = useAuth();
  const params: { type?: string; next?: string } = useRouteParams();
  const navigate = useNavigate();

  const [open, setOpen] = useState(props.open || false);
  const [formAlert, setFormAlert] = useState(null);

  const onDone = () => {
    setOpen(false);
    props.onClose();
  };

  const handleFormAlert = (data) => {
    setFormAlert(data);
  };

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  if (!open) {
    return null;
  }

  return (
    <Dialog open onClose={onDone}>
      <DialogTitle textAlign="center">
        Get {commonConstants.FREE_CREDITS} free credits when you join.
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={onDone}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>
      <DialogContent>
        <Container maxWidth="sm">
          {formAlert && (
            <Box mb={4}>
              <Alert severity={formAlert.type}>{formAlert.message}</Alert>
            </Box>
          )}
          <AuthSocial
            providers={["google", "facebook", "apple"]}
            onAuth={() => {
              // Redirect if signed in
              if (auth.user) {
                navigate(params.next || "/");
              }
            }}
            onError={(message) => {
              handleFormAlert({
                type: "error",
                message,
              });
            }}
          />
          <Box textAlign="center" fontSize={12} my={2}>
            OR
          </Box>
          <AuthForm onFormAlert={handleFormAlert} />
          <Box my={2} fontSize={11}>
            By signing up, you agree to our{" "}
            <LinkMui component={Link} to="legal/terms-of-service">
              Terms of Service
            </LinkMui>{" "}
            and{" "}
            <LinkMui component={Link} to="legal/privacy-policy">
              Privacy Policy
            </LinkMui>
            , and to receive our promotional emails (opt out any time).
          </Box>
        </Container>
      </DialogContent>
    </Dialog>
  );
}

export default AuthModal;
